// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"e069c78b","307":"0f3bdf79","511":"5cc707da","513":"ec9bd83d","787":"8f606988"}[chunkId] + ".chunk.js";
};